import { Component, OnDestroy, OnInit } from '@angular/core';
import { faUndo } from '@fortawesome/free-solid-svg-icons';
import { EventService, MaterialService, ModalClass } from '@evorait/pace-core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { startWith, take, takeUntil, tap } from 'rxjs/operators';
import { MaterialReturnP58Component } from '../../../../material/material-return-p58/material-return-p58.component';
import MaterialReturnP58Model from '../../../../material/material-return-p58/material-return-p58.model';

@Component({
    selector: 'pace-return-material',
    templateUrl: './return-material.component.html',
    styleUrls: ['./return-material.component.scss'],
})
export class ReturnMaterialComponent implements OnInit, OnDestroy {
    public faUndo = faUndo;
    public numberOfMaterialsToBeReturned = 0;
    private destroy$ = new Subject<void>();
    private isMaterialReturnModalOpen = false;
    private modalRef?: BsModalRef;

    public constructor(
        private readonly materialService: MaterialService,
        private readonly eventService: EventService,
        private readonly modalService: BsModalService,
    ) {}

    public ngOnInit(): void {
        this.eventService.refreshMaterialReturnCount$
            .pipe(
                startWith(undefined),
                tap(() => {
                    this.numberOfMaterialsToBeReturned = this.totalMaterialToBeReturned();
                }),
                takeUntil(this.destroy$),
            )
            .subscribe();
    }

    public openMaterialReturn(): void {
        if (this.isMaterialReturnModalOpen) {
            return; // Prevent opening multiple modals
        }
        this.isMaterialReturnModalOpen = true;
        this.materialService
            .updateLocalStorageMaterialsWithBackendDataAndSave()
            .pipe(take(1))
            .subscribe(() => {
                this.modalRef = this.modalService.show(MaterialReturnP58Component, {
                    backdrop: 'static',
                    class: ModalClass.MODAL_LARGE,
                    initialState: {
                        model: new MaterialReturnP58Model(),
                    },
                    ariaLabelledBy: 'material-return-p58-modal-title',
                });
                this.setupModalCloseHandler();
            });
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
    }

    // subscribe modal instance to update flag when modal is closed
    private setupModalCloseHandler(): void {
        this.modalRef?.onHidden?.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.isMaterialReturnModalOpen = false;
        });
    }

    private totalMaterialToBeReturned(): number {
        return this.materialService.getAllReturnsFromLocalStorage().length;
    }
}
